import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { getDetailSegment, getHeaderTUDF } from "../../../utils/buro";
import { Button } from "../layer/wrapper";
import { format, differenceInDays } from "date-fns";
import _ from "lodash";
import FileSaver from "file-saver";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../../utils/reinstallments";
import { API } from "aws-amplify";
import { getFilterLoanBuro } from "../BuroMainTwo";
import iconv from "iconv-lite";
import { calReportAging } from "../../../utils/calReportAging";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

// const iconv = require("iconv-lite");

function ExportBuro({ loan = [], buroDate = new Date(), interest }) {
  const [loadingExport, setLoadingExport] = useState(false);
  const [error, setError] = useState(null);
  const [dataCsv, setDataCsv] = useState("");
  const [countExport, setCountExport] = useState(0);

  useEffect(async () => {
    if (dataCsv) {
      const filename = `TUCRS-MHS-${format(new Date(buroDate), "yyyy-MM")}.txt`;
      const buffer = iconv.encode(dataCsv, "874");
      const buroBlob = new Blob([buffer]);
      FileSaver.saveAs(buroBlob, filename);
    }
  }, [dataCsv]);

  const onClickExportBuro = async () => {
    try {
      setLoadingExport(true);

      let filterLoan = loan.map((item) => {
        let newLoan = {};
        if (item.loan_status === "DONE") {
          let lastEvidence = item.evidence[item.evidence.length - 1];
          let lastPaidDate = getCurrentLocalDateTime(
            new Date(lastEvidence.paid_date)
          );

          if (
            lastPaidDate.fullDate > getCurrentLocalDateTime(buroDate).fullDate
          ) {
            newLoan = reinstallments(item, new Date(buroDate), interest);
          }
        }

        const calNewLoan = calcuratorInterestTwo(
          { ...item, ...newLoan },
          {
            where: { paid_date: new Date(buroDate) },
            dataInterest: interest,
          }
        );

        const loanInterest = interest?.Items?.find(
          (it) => it.type === item.type
        );

        const includeLoan = {
          ...newLoan,
          ...calNewLoan,
          loanInterest,
          original: item,
          checked: true,
        };

        return includeLoan;
      });

      // console.log("filterLoan", filterLoan);

      setCountExport(filterLoan.length);
      setDataCsv(
        `${getHeaderTUDF({
          env: "production",
          dataExport: filterLoan,
          currentDate: buroDate,
        })}\n${getDetailSegment({
          dataExport: filterLoan,
          currentDate: new Date(buroDate),
        })}TRLR`
      );
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingExport(false);
    }
  };

  return (
    <div>
      <Button
        onClick={onClickExportBuro}
        disabled={loadingExport || loan?.length === 0}
        loading={loadingExport}
      >
        {countExport > 0 && countExport} Export Buro Selected
      </Button>
      <CSVLink
        id="csv-link"
        hidden
        data={dataCsv}
        filename={`TUCRS-MHS-${format(new Date(buroDate), "yyyy-MM")}.txt`}
      />
    </div>
  );
}

export default ExportBuro;
